<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12" md="2">
        <h2>
          <v-icon class="mr-2">
            mdi-account-outline
          </v-icon>
          ユーザ
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="name"
                        dense
                        hide-details="auto"
                        label="氏名"
                        outlined
                        clearable
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="name = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="role"
                        :items="userRoles"
                        dense
                        hide-details="auto"
                        label="ロール"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="withoutInvisible"
                        dense
                        label="非表示を表示しない"
                        persistent-hint
                        @change="searchButtonClickEvent()"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <!-- ボタン -->
    <v-row>
      <v-col cols="12" class="text-right">
        <template
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-btn
            color="info"
            @click="exportButtonClickEvent"
          >
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
          </v-btn>
          &nbsp;
          <v-btn
            color="info"
            @click="importButtonClickEvent"
          >
            <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
          </v-btn>
        </template>
        <template
          v-else
        >
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                dark
                v-bind="attrs"
                v-on="on"
              >
                CSVファイル
                <v-icon small>
                  mdi-file-outline
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="exportButtonClickEvent"
              >
                <v-list-item-title>
                  CSV出力
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="importButtonClickEvent"
              >
                <v-list-item-title>
                  CSV取込
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        &emsp;
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          ユーザの追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat class="rounded-card">
          <v-data-table
            :headers="tableHeaders"
            :items="users"
            disable-pagination
            :items-per-page="-1"
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.image_url`]="{ item }">
              <v-list-item-avatar color="primary">
                <div style="height: 60px">
                  <v-img
                    :src="item.image_url"
                    max-height="60"
                    max-width="60"
                    contain
                  />
                </div>
                <span
                  v-if="!item.image_url"
                  class="primary white--text"
                >
                  {{ item.name.slice(0, 2) }}
                </span>
              </v-list-item-avatar>
            </template>
            <template v-slot:[`item.login_id`]="{ item }">
              <span :title="item.login_id">{{ item.login_id | truncate(30) }}</span>
            </template>
            <template v-slot:[`item.email`]="{ item }">
              <span :title="item.email">{{ item.email | truncate(30) }}</span>
            </template>
            <template v-slot:[`item.role`]="{ item }">
              {{ item.role | user_role }}
            </template>
            <template v-slot:[`item.last_login_at`]="{ item }">
              {{ item.last_login_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.invisible`]="{item}">
              {{ item.invisible ? '非表示' : '' }}
            </template>
            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                icon
                color="info darken-2"
                @click="showButtonClickEvent(item)"
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="info"
                @click="showButtonClickEvent(item)"
              >
                参照
              </v-btn>
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                color="info darken-2"
                icon
                @click="editButtonClickEvent(item)"
              >
                <v-icon>mdi-note-edit</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="info"
                @click="editButtonClickEvent(item)"
              >
                編集
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- アップグレード誘導モーダル -->
    <trial-plan-guide-dialog
      :enable-dialog="enableTrialPlanGuideDialog"
      :from-user="true"
      @closeCallback="dialogCloseCallback"
    />

  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import TrialPlanGuideDialog from '../../dialogs/_TrialPlanGuideDialog'

export default {
  name: 'DriverMasterUserIndex',
  components: {
    CustomPagination,
    TrialPlanGuideDialog,
  },
  mixins: [
    DownloadMixin,
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      canUseAddButton: false,
      totalVisible: 7,
      name: null,
      role: null,
      withoutInvisible: true,
      withDeleted: false,
      userRoles: [
        { value: 'admin_user', text: '支店/営業所管理者' },
        { value: 'plain_user', text: '一般' },
        { value: 'driver_user', text: 'ドライバー' },
      ],
      tableHeaders: [
        { text: '', value: 'image_url', align: 'center' },
        { text: 'No', value: 'no' },
        { text: '氏名', value: 'name' },
        { text: 'ログインID', value: 'login_id' },
        { text: 'ロール', value: 'role' },
        { text: 'メールアドレス', value: 'email' },
        { text: '最終ログイン日時', value: 'last_login_at' },
        { text: '非表示', value: 'invisible' },
        { text: '詳細・招待/編集', value: 'editable', align: 'end' },
      ],
      enableTrialPlanGuideDialog: false,
      users: []
    }
  },
  computed: {
    ...mapState('DriverMasterUser', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapState("DriverTenantConfiguration", {
      isTrialPlan: 'use_trial_plan',
    }),
    ...mapGetters('DriverMasterUser', [
      'hasResult'
    ]),
  },
  watch: {
    userName (newVal) {
      this.saveCondition({ name: newVal })
    },
    userRole (newVal) {
      this.saveCondition({ role: newVal })
    },
  },
  created() {

    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.name = this.searchCondition.name
    this.role = this.searchCondition.role
    this.withoutInvisible = this.searchCondition.without_invisible
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchUser()
  },
  methods: {
    ...mapActions('DriverMasterUser', {
      fetchUsers: 'index',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
      checkUsers: 'check',
    }),
    /**
     * 追加ボタン押下イベント
     * お試しプランの場合、10人までしか登録できないようにする
     */
    addButtonClickEvent () {
      if (this.isTrialPlan) {
        this.checkUsers().then((content) => {
          if (content.pagination.total_count < 10) {
            this.$router.push({name: 'DriverMasterUserNew'})
          } else {
            this.enableTrialPlanGuideDialog = true
          }
        })
      } else {
        this.$router.push({name: 'DriverMasterUserNew'})
      }
    },
    showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterUser', params: { id: item.id }})
    },
    editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterUserEdit', params: { id: item.id }})
    },
    importButtonClickEvent () {
      this.$router.push({name: 'DriverMasterUserCsvImport'})
    },
    exportButtonClickEvent () {

      let params = this.buildParam('csv')
      this.fetchUsers(params).then((content) => {
        this.downloadCsv(content, 'ユーザ')
      })
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchUser()
    },
    changePage(page) {
      this.page = page;
      this.searchUser()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchUser()
    },
    searchUser () {
      let params = this.buildParam('json')
      this.fetchUsers(params).then((content) => {
        this.users = content.users
      })
    },
    buildParam (format) {
      const params = {
        name: this.name,
        role: this.role,
        without_invisible: this.withoutInvisible,
        page: this.page,
        limit: this.perPage,
        format: format
      }
      return params
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enableTrialPlanGuideDialog = false;
    },
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
